import { ColorPickerPanel } from './components/Panel';
import { ColorPicker as AdpColorPicker } from './components/Picker';
export var ColorPicker = Object.assign(AdpColorPicker, {
  Panel: ColorPickerPanel
});